import { createSlice } from "@reduxjs/toolkit";

import { fetchCaptureActivityFeed } from "./actions";

export const initialState = {
  events: [],
  isLoading: false,
  isLoadingMore: false,
  error: null,
  search: "",
  sort: { field: "dateTime", direction: "DESC" },
  total: 0,
  filteredTotal: 0,
  hasMore: false,
};

const DEFAULT_ERROR = "Failed to load activity";

const captureActivitySlice = createSlice({
  name: "captureActivity",
  initialState,
  reducers: {
    setCaptureActivitySearch: (state, action) => {
      state.search = action.payload ?? "";
    },
    setCaptureActivitySort: (state, action) => {
      state.sort = action.payload;
    },
    resetCaptureActivityError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCaptureActivityFeed.pending, (state, action) => {
        const isFirstPage = (action.meta.arg?.offset ?? 0) === 0;
        state.isLoading = isFirstPage;
        state.isLoadingMore = !isFirstPage;
        state.error = null;
      })
      .addCase(fetchCaptureActivityFeed.fulfilled, (state, action) => {
        const { offset, rows, total, filteredTotal } = action.payload;
        state.isLoading = false;
        state.isLoadingMore = false;
        state.events = offset === 0 ? rows : [...state.events, ...rows];
        state.total = total;
        state.filteredTotal = filteredTotal;
        state.hasMore = state.events.length < filteredTotal;
      })
      .addCase(fetchCaptureActivityFeed.rejected, (state, action) => {
        state.isLoading = false;
        state.isLoadingMore = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export const {
  setCaptureActivitySearch,
  setCaptureActivitySort,
  resetCaptureActivityError,
} = captureActivitySlice.actions;

export default captureActivitySlice.reducer;
